import { Companion_getInstance2o9uk4k3kfl5 as Companion_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/uuid/Uuid.mjs';
import {
  toNotBlankString1ovj48s0kinvm as toNotBlankString,
  NotBlankString__toString_impl_5tex9r3bdt5aydt9d7j as NotBlankString__toString_impl_5tex9r,
  NotBlankString__hashCode_impl_fxqzj418fmehvdt9fzl as NotBlankString__hashCode_impl_fxqzj4,
  NotBlankString2t6vf2scdbmna as NotBlankString,
} from '../../../../../../types-types/kotools/types/text/NotBlankString.mjs';
import {
  throwOnFailure24snjmtlqgzo8 as throwOnFailure,
  _Result___get_value__impl__bjfvqg9vwgdwmhxc4m as _Result___get_value__impl__bjfvqg,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      c2c() {
        // Inline function 'kotlin.getOrThrow' call
        var this_0 = toNotBlankString(Companion_getInstance().lu().toString());
        throwOnFailure(this_0);
        var tmp$ret$0 = _Result___get_value__impl__bjfvqg(this_0).b2b_1;
        return new (PairingSetId())(tmp$ret$0);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  return Companion_instance;
}
var PairingSetIdClass;
function PairingSetId() {
  if (PairingSetIdClass === VOID) {
    class $ {
      constructor(value) {
        this.r2e_1 = value;
      }
      toString() {
        return 'PairingSetId(value=' + NotBlankString__toString_impl_5tex9r(this.r2e_1) + ')';
      }
      hashCode() {
        return NotBlankString__hashCode_impl_fxqzj4(this.r2e_1);
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof PairingSetId()))
          return false;
        if (!equals(new (NotBlankString())(this.r2e_1), new (NotBlankString())(other.r2e_1)))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'PairingSetId');
    PairingSetIdClass = $;
  }
  return PairingSetIdClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  PairingSetId as PairingSetId2cohvchymqgsy,
  Companion_instance as Companion_instance312armtl4r2se,
};
//endregion

//# sourceMappingURL=PairingSetId.mjs.map
